
export const porteData = [
    'Microempreendedor Individual (MEI)',
    'Microempresa (ME)',
    'Empresa de Pequeno Porte (EPP)',
    'Empresa de Médio Porte',
    'Grande Empresa'
]